import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { PathName } from "../../../../constants/PathName";
import { useGetFormRecoil } from "../formDetail.service";
import "./formContent.scss";

export const FormSuccessMessage = () => {
	const { form } = useGetFormRecoil();
	const history = useHistory();
	const [countdown, setCountdown] = useState(5);

	useEffect(() => {
		if (countdown <= 0) {
			history.push(PathName.DASHBOARD);
			return;
		}

		const timer = setTimeout(() => {
			setCountdown(countdown - 1);
		}, 1000);

		return () => clearTimeout(timer);
	}, [countdown, history]);

	return (
		<div className="formContent">
			<h1 id="titleForHeader">Thank you for completing "{form?.name ?? ""}"</h1>
			<p className="formContent-description">
				You will be redirected to the dashboard in {countdown} second{countdown !== 1 ? "s" : ""}.
			</p>
		</div>
	);
};
